import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Tab content area.
/* Cannot desctructure the for keyword here, unfortunately. */
export default function TabPanel(props) {
  const {
    activeName,
    className,
    children,
    a11yKeyboard,
    a11yRolesErb,
  } = props;
  const isActive = props.for === activeName;
  const a11yAttrs = a11yKeyboard || a11yRolesErb
    ? {
        role: 'tabpanel',
        id: `tabpanel-${props.for}`,
        'aria-labelledby': `tab-${props.for}`,
        ...(a11yRolesErb && !isActive ? { hidden: true } : {}),
      }
    : {};
  return (
    <div
      style={{ display: isActive ? 'block' : 'none' }}
      className={classnames('tab-panel', className)}
      {...a11yAttrs}
    >
      {children}
    </div>
  );
}

TabPanel.propTypes = {
  activeName: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  for: PropTypes.string.isRequired,
  a11yKeyboard: PropTypes.bool,
  a11yRolesErb: PropTypes.bool,
};

TabPanel.defaultProps = {
  className: '',
  activeName: null,
  a11yKeyboard: false,
  a11yRolesErb: false,
};
